import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WTPEquipmentTypePostDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPSidebarSlice/EquipmentTypeSlice';


export default function WTPEquipmentTypeMasterPagePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData} = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    const [IsOpen, setIsOpen] = useState(false)

    const [EquipmentTypeTextField, setEquipmentTypeTextField] = useState({
        equipmentType: Flag === 'Update' ? rowData.equipmentType : '',
    });

    const handleInputChange = (e) => {
        setEquipmentTypeTextField({ ...EquipmentTypeTextField, [e.target.name]: e.target.value })
    }

// console.log(rowData.m_wtP_EquipmentTypeID)

    const handlePost = () => {
        const data = {
            M_WTP_EquipmentTypeID: Flag === 'Update' ? rowData.m_wtP_EquipmentTypeID : '0',
            EquipmentType: EquipmentTypeTextField.equipmentType,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,

        }
        dispatch(WTPEquipmentTypePostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Equipment Type Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Type </b></label>
                                        <input type="text"
                                            className="form-control"
                                            name='equipmentType'
                                            value={EquipmentTypeTextField.equipmentType}
                                            onChange={ handleInputChange}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost())}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}